export enum AuthModalStep {
  Login = "Login",
  Register = "Register",
  VerifyEmail = "VerifyEmail",
  ForgotPassword = "ForgotPassword",
  VerifyReset = "VerifyReset",
  NewPassword = "NewPassword"
}

export type OtpType = "signup" | "recovery"

export type AuthResult = {
  success: boolean
  message: string
  requiresVerification: boolean
}

export type VerifyOtpResult = {
  success: boolean
  message: string
}
